import React from "react";

// A status pill of a monitor row: `map` is one of the status maps in features/monitor.constants.js.
export default function StatusPill({ status, map }) {
  const meta = map[status] ?? { label: status ?? "—", classes: "bg-surface_alt text-text_secondary border-border" };
  return <span className={`inline-flex items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-[11px] font-semibold ${meta.classes}`}>{meta.label}</span>;
}
